import { render, staticRenderFns } from "./IconDiners.vue?vue&type=template&id=1114cec9&"
import script from "./IconDiners.vue?vue&type=script&lang=ts&"
export * from "./IconDiners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports